export const API_ROUTES = {
  CALLBACK_ENDPOINT: '/api/auth/callback',
  VERIFY_TOKEN_ENDPOINT: '/api/auth/verify-token',
  REFRESH_TOKEN_ENDPOINT: '/api/auth/refresh-access-token',
  // PRODUCT_BY_ID: (id: number) => `/api/products/${id}`,
  ADMIN_CARD_ENDPOINT: '/api/admin/card',
  ADMIN_USER_ENDPOINT: '/api/admin/user',
  ADMIN_AFFILIATION_ENDPOINT: '/api/admin/affiliation',
  ADMIN_CARDSET_ENDPOINT: '/api/admin/cardset',
  NOTIFICATION_PROCESSING_GET_ENDPOINT: '/cloud-app/notification-processing/get',
  NOTIFICATION_PROCESSING_SEND_ENDPOINT: '/cloud-app/notification-processing/send',
  NOTIFICATION_PROCESSING_ADD_ENDPOINT: '/cloud-app/notification-processing/add',
  NOTIFICATION_HISTORY_GET: '/cloud-app/notification-history/get',
  NOTIFICATION_HISTORY_RESEND: '/cloud-app/notification-history/resend',
  NOTIFICATION_HISTORY_CANCEL: '/cloud-app/notification-history/cancel',
  REGISTED_INFORMATION_GET_LIST: '/cloud-app/registration-information-list/get',
  REGISTED_INFORMATION_DOWNLOAD_ALL_IMAGES: '/cloud-app/registration-information-list/download-all-images',
  REGISTED_INFORMATION_DOWNLOAD_IMAGES: '/cloud-app/registration-information-list/download-image',
  REGISTED_INFORMATION_EDIT: '/cloud-app/registration-information-list/edit',
  REGISTED_INFORMATION_DELETE: '/cloud-app/registration-information-list/delete',
  REGISTED_INFORMATION_CREATE: '/cloud-app/registration-information-list/create',
  REGISTED_INFORMATION_READ_DOCUMENT: '/api/process-image-sk-test/document-analyze',
  ADMIN_USER_LIST_ENDPOINT: '/api/admin/user/list',
  ADMIN_HISTORY_LIST_ENDPOINT: '/api/admin/log/list',
  ADMIN_CARD_LIST_ENDPOINT: '/api/admin/card/list',
  ADMIN_CARD_GROUP_LIST_ENDPOINT: '/api/admin/card/groups',
  ADMIN_USER_CREATE_ENDPOINT: '/api/admin/user/create',
  ADMIN_USER_EDIT_ENDPOINT: '/api/admin/user/update',
  ADMIN_USER_DELETE_ENDPOINT: '/api/admin/user/deactive',
  ADMIN_AFFILIATION_LIST_ENDPOINT: '/api/admin/affiliation/list',
  ADMIN_HISTORY_ENDPOINT: '/api/admin/log',
  ADMIN_DOWNLOAD_LIST_ENDPOINT: '/download-items',
  BULK_NOTIFICATION_EXECUTE_ENDPOINT: '/cloud-app/bulk-notification/execute',
  BULK_NOTIFICATION_SCHEDULE_CREATE: '/cloud-app/bulk-notification/schedule',
  BULK_NOTIFICATION_SCHEDULES_LIST: '/cloud-app/bulk-notification/schedules',
  BULK_NOTIFICATION_SCHEDULE_STOP: (id: number) => `/cloud-app/bulk-notification/schedule/${id}/stop`,
  BULK_NOTIFICATION_SCHEDULE_RESUME: (id: number) => `/cloud-app/bulk-notification/schedule/${id}/resume`,
  BULK_NOTIFICATION_SCHEDULE_UPDATE: (id: number) => `/cloud-app/bulk-notification/schedule/${id}`,
  BULK_NOTIFICATION_SCHEDULE_DELETE: (id: number) => `/cloud-app/bulk-notification/schedule/${id}`,
  ADMIN_DOCUMENT_ANALYZE: '/api/process-image/document-analyze',
  ADMIN_DOCUMENT_CONFIRM: '/api/process-image/document-confirm',
  ADMIN_USER_ME_SCOPE_ENDPOINT: '/api/admin/user/me/scope',
  ADMIN_USER_SCOPE_ENDPOINT: (userId: string) => `/api/admin/user/${userId}/scope`,
  ADMIN_USER_ALL_SCOPE_ENDPOINT: (userId: string) => `/api/admin/user/${userId}/all-scope`,
}

export const PAGINATION = {
  PAGE: 1,
  PAGE_SIZE: 10,
}